import type { ReactNode } from 'react'
import { createContext, use, useMemo } from 'react'
import type { DeviceType } from '@/lib/device'

interface DeviceInfo {
  deviceType: DeviceType
  isMobile: boolean
  isTablet: boolean
}

const DeviceContext = createContext<DeviceInfo | undefined>(undefined)

interface DeviceProviderProps {
  deviceType: DeviceType
  children?: ReactNode
}

export function DeviceProvider({ deviceType, children }: DeviceProviderProps) {
  const deviceInfo = useMemo<DeviceInfo>(
    () => ({
      deviceType,
      isMobile: deviceType !== 'desktop',
      isTablet: deviceType === 'tablet',
    }),
    [deviceType],
  )

  return <DeviceContext value={deviceInfo}>{children}</DeviceContext>
}

export function useDevice(): DeviceInfo {
  const context = use(DeviceContext)
  if (context === undefined) {
    throw new Error('useDevice must be used within a DeviceProvider')
  }
  return context
}

export function useIsMobile(): boolean {
  return useDevice().isMobile
}
